import React from "react";
import { getProductData, getProductNameBy } from "@/src/services/productService";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import ApplicationForm from "@/src/components/ApplicationForm/ApplicationForm";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import useProductParams from "@/src/hooks/useProductParams";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

export default function ApplicationFormPage() {
  const { productName, productId } = useProductParams();
  const productClassName = getProductNameBy("urlPartShort", productName);
  const productApiUri = getProductData(productClassName, "apiUri");
  const { data: product, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });

  return <LayoutProtectedRoutes sidebar={false}>{isLoading ? <LegalbirdLoader /> : <ApplicationForm product={product} />}</LayoutProtectedRoutes>;
}
